import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from '../../components/Modal/CustomModal';
import DivContainerBody from '../../components/DivContainerBody';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

    const DeleteModal = (props) => {
    const { onClickFn, onHide, isReset, isAllReset, title_modal, description, data, element_modal } = props;
    const { t, i18n } = useTranslation();

    const isSpanish = i18n.language === 'es';

    const getFormattedMessage = (key) => {
        const translated = t(key);
        return isSpanish && !translated.startsWith('¿') ? `¿${translated}` : translated;
    };

    const handleDelete = (e) => {
        onClickFn(e);
        onHide();
        if (isReset) isReset([]);

        if (isAllReset) isAllReset(false);
    };

    return (
        <CustomModal
            title={t(title_modal)}
            size='md'
            buttonConfirm='delete'
            confirmClass={'btn-delete-step'}
            {...props}
            onHide={() => {
                onHide();
                if (isReset) isReset([]);

                if (isAllReset) isAllReset(false);
            }}
            onConfirm={() => {
                handleDelete();
            }}
        >
            <DivContainerBody>
                <p className='d-flex justify-content-center align-content-center flex-wrap-no-gap align-items-center text-uppercase fs-14px'>
                {getFormattedMessage(description || 'are_you_sure_you_want_to_delete')}
                    <span className={'ibl-font-w-600 font-color-general-950 mx-1'}>{data?.length}</span>
                    <span className={'ibl-font-w-600 font-color-general-950 mx-1'}>{t(element_modal).toLowerCase()}</span>?
                </p>
            </DivContainerBody>
        </CustomModal>
    );
};

export default DeleteModal;
